import React from 'react';
import { cn } from '@/lib/utils';

export const IntegrityScore = ({ score, size = 'md', className }) => {
  const getScoreColor = (score) => {
    if (score >= 7) return '#2E7D32'; // Green
    if (score >= 4) return '#F57F17'; // Orange
    return '#C62828'; // Red
  };

  const scorePercentage = (score / 10) * 100;
  const circumference = 2 * Math.PI * 45;
  const strokeDashoffset = circumference - (scorePercentage / 100) * circumference;

  const sizes = {
    sm: { container: 'w-24 h-24', text: 'text-2xl', label: 'text-xs' },
    md: { container: 'w-32 h-32', text: 'text-3xl', label: 'text-sm' },
    lg: { container: 'w-40 h-40', text: 'text-4xl', label: 'text-base' },
  };

  const sizeClasses = sizes[size] || sizes.md;

  return (
    <div className={cn('relative inline-flex items-center justify-center', sizeClasses.container, className)} data-testid="integrity-score-widget">
      <svg className="transform -rotate-90" width="100%" height="100%" viewBox="0 0 100 100">
        <circle
          cx="50"
          cy="50"
          r="45"
          stroke="#E2E8F0"
          strokeWidth="8"
          fill="transparent"
        />
        <circle
          cx="50"
          cy="50"
          r="45"
          stroke={getScoreColor(score)}
          strokeWidth="8"
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className="score-circle"
          strokeLinecap="round"
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className={cn('font-black text-[#0F1C2E]', sizeClasses.text)} data-testid="score-value">
          {score.toFixed(1)}
        </span>
        <span className={cn('font-medium text-[#94A3B8] uppercase tracking-wide', sizeClasses.label)}>
          /10
        </span>
      </div>
    </div>
  );
};
